"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElectronicSignatureDialog = void 0;
const react_1 = __importStar(require("react"));
const formik_1 = require("formik");
const Yup = __importStar(require("yup"));
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_2 = require("@sierralabs/core");
const react_material_ui_formik_1 = require("@sierralabs/react-material-ui-formik");
const usePasswordRecover_1 = require("../../hooks/usePasswordRecover");
const UserContext_1 = require("../../UserContext");
const ElectronicSignature_hooks_1 = require("./ElectronicSignature.hooks");
const MeaningAlert = ({ message }) => {
    const success = ['approve', 'approving'].some(match => {
        return message.includes(match);
    });
    const error = message === null || message === void 0 ? void 0 : message.includes('reject');
    const severity = success ? 'success' : error ? 'error' : 'info';
    return react_1.default.createElement(lab_1.Alert, { severity: severity }, message);
};
const ElectronicSignatureDialog = props => {
    const { open, meaning, reasonLabel, onCancel, onSigned } = props;
    const nowRef = (0, react_1.useRef)(new Date());
    const reasonRef = (0, react_1.useRef)();
    const onSignedRef = (0, react_1.useRef)(onSigned);
    const formikRef = (0, react_1.useRef)(null);
    const { user } = (0, UserContext_1.useUserContext)();
    const [email, setEmail] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)();
    const [alertMessage, setAlertMessage] = (0, react_1.useState)();
    const { success, isLoading: isRecovering, error: recoverError, doPasswordRecover } = (0, usePasswordRecover_1.usePasswordRecover)();
    // const { isJiraServer: isJira } = useContext(JiraServerContext);
    // const { isAvailable: isConnectAvailable } = useJiraConnectAPI();
    const isAvailable = false; // isJira || isConnectAvailable;
    const { signed, isLoading, error: signError, post } = (0, ElectronicSignature_hooks_1.useElectronicSignature)();
    const isPasswordSet = !(user &&
        typeof user.isPasswordSet === 'boolean' &&
        !user.isPasswordSet);
    const shouldSetupPassword = isAvailable && !isPasswordSet && !success;
    const timezone = (0, react_1.useMemo)(() => {
        const now = nowRef.current.toString();
        const splitIndex = now.indexOf(' ', now.lastIndexOf(':'));
        const value = now.slice(splitIndex, now.length);
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        return `${value} (${timezone})`;
    }, []);
    (0, react_1.useEffect)(() => {
        onSignedRef.current = onSigned;
    }, [onSigned]);
    (0, react_1.useEffect)(() => {
        var _a;
        (_a = formikRef.current) === null || _a === void 0 ? void 0 : _a.setSubmitting(isLoading);
    }, [isLoading]);
    (0, react_1.useEffect)(() => {
        if (!success && recoverError) {
            setError(recoverError);
        }
        else if (!signed && signError) {
            setError(signError);
        }
        else {
            setError(undefined);
        }
    }, [success, recoverError, signed, signError]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (signed) {
            (_a = onSignedRef.current) === null || _a === void 0 ? void 0 : _a.call(onSignedRef, reasonRef.current);
        }
    }, [signed]);
    (0, react_1.useEffect)(() => {
        if (error) {
            setAlertMessage({
                severity: 'error',
                message: error.statusCode === 401 ? (react_1.default.createElement(react_1.default.Fragment, null,
                    "Sorry, the email and password does not match. Please try again or click ",
                    react_1.default.createElement("strong", null, "Reset Password"),
                    " below and we'll send a link to reset your password to ",
                    react_1.default.createElement("strong", null, email),
                    ".")) : (error.message)
            });
        }
        else if (success) {
            setAlertMessage({
                severity: 'info',
                message: (react_1.default.createElement(react_1.default.Fragment, null,
                    "We sent a link to reset your password to ",
                    react_1.default.createElement("strong", null, email),
                    ". Please follow the instructions to set a new password then return to this window to continue signing."))
            });
        }
        else if (shouldSetupPassword) {
            setAlertMessage({
                severity: 'warning',
                message: (react_1.default.createElement(react_1.default.Fragment, null,
                    "Please setup your password to continue with electronic signing.",
                    ' ',
                    react_1.default.createElement("strong", null, "Enter your email"),
                    " above and click on",
                    ' ',
                    react_1.default.createElement("strong", null, "Reset Password"),
                    " to receive an email to setup your password."))
            });
        }
        else {
            setAlertMessage(undefined);
        }
    }, [shouldSetupPassword, success, error, email]);
    const validationSchema = Yup.object({
        email: Yup.string()
            .lowercase()
            .email()
            .required('Required')
            .test('match-user-email', `Does not match the email for this account (${user === null || user === void 0 ? void 0 : user.email})`, value => !!(user && user.email.toLowerCase() === value)),
        password: Yup.string().required('Required')
    });
    return (react_1.default.createElement(core_1.Dialog, { open: open, onClose: onCancel },
        react_1.default.createElement(formik_1.Formik, { innerRef: formikRef, initialValues: { email: '', password: '', reason: '' }, validationSchema: validationSchema, onSubmit: values => {
                setError(undefined);
                setAlertMessage(undefined);
                const { reason } = values, dto = __rest(values, ["reason"]);
                if (typeof reason !== 'undefined') {
                    reasonRef.current = reason || null;
                }
                post(dto);
            } },
            react_1.default.createElement(formik_1.Form, { autoComplete: 'off' },
                react_1.default.createElement(core_1.DialogTitle, null, "Electronic Signature"),
                react_1.default.createElement(core_1.DialogContent, null,
                    react_1.default.createElement(core_1.DialogContentText, { component: 'div' },
                        react_1.default.createElement(MeaningAlert, { message: meaning })),
                    react_1.default.createElement(react_material_ui_formik_1.FormikGrid, null,
                        react_1.default.createElement(react_material_ui_formik_1.FormikTextField, { autoFocus: true, type: 'text', name: 'email', label: 'Email', grid: { xs: 12, md: shouldSetupPassword ? 12 : 6 }, onChange: event => setEmail(event.target.value.toLowerCase()) }),
                        !shouldSetupPassword && (react_1.default.createElement(react_material_ui_formik_1.FormikTextField, { type: 'password', name: 'password', label: 'Password', grid: { xs: 12, md: 6 } })),
                        reasonLabel && (react_1.default.createElement(react_material_ui_formik_1.FormikTextField, { type: 'text', name: 'reason', label: reasonLabel })),
                        react_1.default.createElement(core_1.Grid, { item: true, xs: 12 },
                            react_1.default.createElement(core_1.Box, null,
                                react_1.default.createElement(core_1.Typography, { variant: 'body2' }, (0, core_2.formatDate)(nowRef.current)),
                                react_1.default.createElement(core_1.Typography, { variant: 'caption', color: 'textSecondary' }, timezone)))),
                    alertMessage && (react_1.default.createElement(core_1.Box, { mt: 1 },
                        react_1.default.createElement(lab_1.Alert, { severity: alertMessage.severity }, alertMessage.message)))),
                react_1.default.createElement(core_1.DialogActions, null,
                    isAvailable && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(core_1.Button, { color: 'primary', variant: 'contained', onClick: () => {
                                setError(undefined);
                                setAlertMessage(undefined);
                                doPasswordRecover(email);
                            }, disabled: isRecovering ||
                                !validationSchema.isValidSync({ email, password: '***' }), endIcon: isRecovering && (react_1.default.createElement(core_1.CircularProgress, { color: 'primary', size: 20 })) }, "Reset Password"),
                        react_1.default.createElement("div", { style: { flex: 1 } }))),
                    react_1.default.createElement(core_1.Button, { onClick: onCancel }, "Cancel"),
                    react_1.default.createElement(react_material_ui_formik_1.FormikButton, null, "Sign"))))));
};
exports.ElectronicSignatureDialog = ElectronicSignatureDialog;
exports.default = exports.ElectronicSignatureDialog;
//# sourceMappingURL=ElectronicSignatureDialog.js.map